export default __webpack_public_path__ + "static/media/email.abdbd679.svg";